import e from"styled-components";import{theme as o}from"../../../theme.js";const i=e.div`
  .mobile {
    display: none;
  }
  @media screen and (max-width: ${o.breakpoints.lg}) {
    .mobile {
      display: block
    }
    .desktop {
      display: none;
    }
  }
`;export{i as Container};
